import type { FormSegment, SegmentTreeNode } from '../../../../../../../../../modules/audiences/AudienceForm/types';

type CreateStateNodeParams = {
  parentId: string;
  districts: FormSegment[];
  allSegmentsById: Map<string, SegmentTreeNode>;
};

export const createStateNode = ({ parentId, districts, allSegmentsById }: CreateStateNodeParams): SegmentTreeNode => {
  const stateSegment = allSegmentsById.get(parentId);

  const stateNode = {
    ...stateSegment,
    children: districts,
  } as SegmentTreeNode;

  return stateNode;
};
